import Blanket from '../../common/Blanket';
import Dialog from '../Dialog';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useWhaleSpaceDataSliceSelector } from '../../../store/modules/whaleSpaceData';
import Button from '../../common/Button';

const DialogMobileBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 322px;
  height: 255px;
  box-sizing: border-box;
`;

const InfoField = styled.div`
  display: flex;
  width: 290px;
  height: 152px;
  flex-flow: column;
  margin: 8px 16px 28px 16px;
`;

const InfoItem = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  align-items: center;
`;

const InfoItemName = styled.div`
  width: 40px;
  margin-right: 16px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #96999c;
`;

const InfoItemValue = styled.div`
  width: 234px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #2f3133;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
`;

export default function UserInfoDialogMobile({ isShow, onClickCloseBtn, onClickLogout }) {
  const { t } = useTranslation();
  const whaleSpaceSlice = useWhaleSpaceDataSliceSelector();
  return (
    <Blanket>
      <Dialog
        title={t('UserInfoDialog.Title')}
        showCloseBtn
        showTitleSeperateLine
        onClickCloseBtn={onClickCloseBtn}
        isShow={isShow}
        isBlanketTransparent>
        <DialogMobileBody>
          <InfoField>
            <InfoItem>
              <InfoItemName>{t('UserInfoDialog.ID')}</InfoItemName>
              <InfoItemValue title={whaleSpaceSlice.userEmail}>
                {whaleSpaceSlice.userEmail}
              </InfoItemValue>
            </InfoItem>
            <InfoItem>
              <InfoItemName>{t('UserInfoDialog.Name')}</InfoItemName>
              <InfoItemValue title={whaleSpaceSlice.userFullName}>
                {whaleSpaceSlice.userFullName}
              </InfoItemValue>
            </InfoItem>
            <InfoItem>
              <InfoItemName>{t('UserInfoDialog.Space')}</InfoItemName>
              <InfoItemValue title={whaleSpaceSlice.userSpaceName}>
                {whaleSpaceSlice.userSpaceName}
              </InfoItemValue>
            </InfoItem>
            <InfoItem>
              <InfoItemName>{t('UserInfoDialog.Position')}</InfoItemName>
              <InfoItemValue title={whaleSpaceSlice.userType}>
                {whaleSpaceSlice.userType}
              </InfoItemValue>
            </InfoItem>
          </InfoField>
          <Button
            cssExt={css`
              width: 140px;
              height: 36px;
              padding: 7px 6px 9px;
              border-radius: 2px;
              border: solid 1px #b1b6bb;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              font-weight: 400;
              font-stretch: normal;
              font-style: normal;
              line-height: normal;
              letter-spacing: normal;
              text-align: center;
              color: #2f3133;
            `}
            onClick={onClickLogout}>
            {t('UserInfoDialog.Logout')}
          </Button>
        </DialogMobileBody>
      </Dialog>
    </Blanket>
  );
}
